import React from "react";

import {
  Form, Select, Tooltip,
} from "antd";

import {
  getSearchableSelectProps,
  renderSelectPopupScrollbar,
  selectPopupClassNames,
} from "../../../../Common/UIComponents/SelectPopupScrollbar";

import MyForm from "../../../../Onboarding/MyForm";
import EditableFields, { PRODUCT_RESERVED_FIELD_KEYS } from "../../../../Onboarding/OnboardingForm/SubForms/FieldsForm/Components/EditableFields";
import FixedValueInput from "../../../../Onboarding/OnboardingForm/SubForms/FieldsForm/Components/FixedValueInput";

import { ReactComponent as Info } from "../../../../../assets/images/onboarding/Info.svg";

import "../../../../Onboarding/OnboardingForm/SubForms/LinkReportForm.css";

export default function OnboardingProductForm({
  layout, form, FORM_NAME, handleInitialValues, getJsonFieldName, handleEditableFields, setSubmitBtnValidation, productDropdownOptions,
}) {
  return (
    <MyForm
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...layout}
      form={form}
      requiredMark={false}
      name={FORM_NAME}
      validateTrigger={["onChange", "onBlur"]}
      initialValues={handleInitialValues("product_info")}
      className="Onboarding__SampleSubmission__Form MyForm OnboardingForm"
    >
      <div className="productDetail">
        <div className="OnboardingFormTitle">Product Details</div>
        <div>
          <div className="FormsContainer_Divider" />
          <Form.Item label={(
            <span className="MyForm__SectionLabel Onboarding__LabelText_Fields">
              Product Sample Submission Form Fields
              <Tooltip title="Info to track the samples you send to the lab.">
                <Info />
              </Tooltip>
            </span>
                      )}
          >
              <Form.Item
                name="sample_type"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <FixedValueInput />
              </Form.Item>
              <Form.Item
                name="date"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <FixedValueInput />
              </Form.Item>
              <Form.Item
                name="physical_category"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <FixedValueInput />
              </Form.Item>
              <EditableFields getJsonFieldName={getJsonFieldName} onGetData={handleEditableFields} removableFieldIndex={2} reservedFieldKeys={PRODUCT_RESERVED_FIELD_KEYS} />
              <div className="FormsContainer_Divider" />
              <Form.Item
                name="product_link"
                label={<span className="MyForm__SectionLabel">Select the field that is associated with the specification for your product :</span>}
                rules={[
                  {
                    required: true, message: "",
                  },
                ]}
                className="LinkReportForm__ProductSpec"
              >
                <Select
                  mode="multiple"
                  allowClear
                  {...getSearchableSelectProps()} // eslint-disable-line react/jsx-props-no-spreading
                  classNames={selectPopupClassNames()}
                  virtual={false}
                  listHeight={256}
                  popupRender={(menu) => renderSelectPopupScrollbar(menu, {
                    optionCount: (productDropdownOptions || []).length,
                  })}
                  options={productDropdownOptions}
                  placeholder="Item Name"
                  onChange={() => {
                    const fieldValue = form.getFieldValue("product_link");
                    const editableFieldsValue = form.getFieldValue("editable_fields");
                    if (fieldValue.length === 0 || editableFieldsValue.includes("")) {
                      setSubmitBtnValidation(false);
                    } else {
                      setSubmitBtnValidation(true);
                    }
                  }}
                />
              </Form.Item>
          </Form.Item>
        </div>
      </div>
    </MyForm>
  );
}
